import { Directive, ElementRef, HostListener, Input } from '@angular/core';

@Directive({
  selector: 'img',
})
export class ImgFallbackDirective {
  @Input() defaultSrc: string = 'assets/img/no-image.svg';

  constructor(private el: ElementRef<HTMLImageElement>) {}

  @HostListener('error')
  onError(): void {
    const element = this.el.nativeElement;
    if (element && element.src && !element.src.includes('assets/img/no-image.svg')) {
      element.src = this.defaultSrc;
    }
  }
}
